import {useEffect, useState} from "react";
import {Bounce, toast} from "react-toastify";
import {TicketFilters} from "../../services/SalesRep/salesrepTicketsService";
import {getComponents} from "../../services/Administrative/componentService";

interface UseGetComponentsProps {
    filters?: TicketFilters;
}

const typeOptions = [
    {value: '', label: 'Seleccione un tipo'},
    {value: 'CONTROLLER', label: 'Controlador'},
    {value: 'TANK', label: 'Tanque'},
    {value: 'DISPENSER', label: 'Dosificador'},
    {value: 'AGITATOR', label: 'Agitador'}
];

const stateOptions = [
    {value: 'AVAILABLE', label: 'Disponible'},
    {value: 'IN_USE', label: 'En Uso'},
    {value: 'BLOCKED', label: 'Bloqueado'}
];

export const useGetComponents = ({ filters = {}, clearFilters }: UseGetComponentsProps & { clearFilters?: () => void }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [components, setComponents] = useState<any>([]);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const addComponentLocally = (newComponent: any) => {
        const transformedComponent = {
            NOMBRE: newComponent.name,
            TIPO: typeOptions.find(option => option.value === newComponent.type)?.label ,
            CLAVE: newComponent.uniqueCode,
            ESTADO: stateOptions.find(option => option.value === newComponent.state)?.label,
            ID: newComponent.id
        }
        setComponents((prevComponents: any) => [...prevComponents, transformedComponent]);
    };

    const updateComponentLocally = (id: number, componentDTO: any) => {
        const transformedComponent = {
            NOMBRE: componentDTO.name,
            TIPO: typeOptions.find(option => option.value === componentDTO.type)?.label ,
            CLAVE: componentDTO.uniqueCode,
            ESTADO: stateOptions.find(option => option.value === componentDTO.state)?.label,
            ID: id
        }

        setComponents((prevComponents:any) => {
            return prevComponents.map((component: any) =>
                component.ID === componentDTO.id
                    ? transformedComponent
                    : component
            );
        });
    }

    useEffect(() => {
        const fetchComponents = async () => {
            try {
                setIsLoading(true);
                const response:any = await getComponents(page, filters);
                setComponents(response.components);
                setPage(response.page);
                setTotalPages(response.totalPages);
            } catch (error:any) {
                if (error.response) {
                    if (error.response.status === 404) {
                        toast.warning(
                            `${error.response.data.message}. Por favor, verifique o limpie los filtros`,
                            {
                                position: 'top-right',
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false,
                                theme: 'colored',
                                transition: Bounce,
                            }
                        );
                        //if (clearFilters) clearFilters();
                    } else {
                        toast.error("Error al obtener los componentes.", {
                            position: 'top-right',
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false,
                            theme: 'colored',
                            transition: Bounce,
                        });
                    }
                } else {
                    toast.error("Error al obtener los components.", {
                        position: 'top-right',
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        theme: 'colored',
                        transition: Bounce,
                    });
                }
            }
            finally {
                setTimeout(() => {setIsLoading(false)}, 600)
            }
        };
        fetchComponents();
    }, [page, filters]);

    return { components, totalPages , isLoading, page, setPage, addComponentLocally, updateComponentLocally };
};
